import moment from "moment";
import {
  DISPLAY_DATE_FORMAT,
  DISPLAY_DATE_TIME_FORMAT,
} from "../Config/DateConfig";

// API dates are stored in UTC but serialised without a "Z", so parse them as UTC
// and convert to the viewer's local time (otherwise BST times show an hour out).
const toLocal = (value) => (value ? moment.utc(value).local() : null);

export const formatDateTime = (value, fallback = "-") =>
  value ? toLocal(value).format(DISPLAY_DATE_TIME_FORMAT) : fallback;

export const formatDate = (value, fallback = "-") =>
  value ? toLocal(value).format(DISPLAY_DATE_FORMAT) : fallback;
